<template>
  <div class="commonTooltip">
    <el-tooltip effect="dark" :content="content" :disabled="isDisable" placement="bottom-start">
      <div>
        <span class="text" :ref="refName" @mouseover="mouseoverHandler">{{ content }}</span>
      </div>
    </el-tooltip>
  </div>
</template>
<script>
export default {
  data () {
    return {
      isDisable: true
    };
  },
  props: {
    refName: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    }
  },
  methods: {
    mouseoverHandler () {
      if (this.$refs[this.refName]) {
        let parentWidth = this.$refs[this.refName].parentNode.offsetWidth;
        let contentWidth = this.$refs[this.refName].offsetWidth;
        this.isDisable = contentWidth <= parentWidth;
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.mouseoverHandler();
    });
  }
};
</script>
<style lang="scss" scoped>
.commonTooltip{
  >.el-tooltip{
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .text{
    cursor: pointer;
  }
}
</style>
